<template>
  <div class="blk_access_details">
    <dl v-if="train" class="access_detail">
      <dt>電車の方</dt>
      <dd v-html="train"></dd>
    </dl>
    <dl v-if="car" class="access_detail">
      <dt>駐車場</dt>
      <dd v-html="car"></dd>
    </dl>
  </div>
</template>

<script>
export default {
  name: 'AccessDetail',
  props: {
    msg: String,
    train: String,
    car: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
